import React from 'react';
import {
	Dialog,
	DialogContent,
	DialogActions,
	DialogTitle,
	Button,
} from '@barracuda-internal/bds-core-v2';
import { useScanLogsTableLogic } from '../scanlog/useScanLogsTableLogic';
import { ScanlogsDataTable } from '../scanlog/ScanlogsDataTable';

interface ScanLogPopupV2Props {
	showScanlog?: boolean;
	closePopup: () => void;
	searchText: string;
	itemId: string;
}

export default function ScanLogPopupV2({
	showScanlog = false,
	closePopup,
	searchText,
	itemId,
}: ScanLogPopupV2Props): JSX.Element {
	const {
		tableData,
		page,
		pageSize,
		isLoading,
		totalRecords,
		dateRange,
		searchValue,
		isSearchFocused,
		columnVisibility,
		sorting,
		setSorting,
		filters,
		sideMenuDropdowns,
		classes,
		isColumnVisibilityDrawerOpen,
		setIsColumnVisibilityDrawerOpen,
		setSideMenuSearchValue,
		datePickerError,
		datePickerErrorMessage,
		handleDateRangeChange,
		handleSearchFieldChange,
		handleRefresh,
		handlePaginationChange,
		handleOnClickItemsPerPageOption,
		handleSideMenuCheckboxChange,
		handleRemoveColumnFilter,
		handleClearAllFilters,
		downloadFile,
		columns,
		generateFilterChips,
		TopBarActions,
		SearchEndAdornment,
		searchInputProps,
	} = useScanLogsTableLogic(itemId);

	return (
		<Dialog
			bdsDialogWidth="large"
			fullWidth
			open={showScanlog}
			onClose={closePopup}
		>
			<DialogTitle>Scan Log for &ldquo;{searchText}&rdquo;</DialogTitle>
			<DialogContent>
				<ScanlogsDataTable
					tableData={tableData}
					page={page}
					pageSize={pageSize}
					isLoading={isLoading}
					totalRecords={totalRecords}
					dateRange={dateRange}
					searchValue={searchValue}
					isSearchFocused={isSearchFocused}
					columnVisibility={columnVisibility}
					sorting={sorting}
					setSorting={setSorting}
					filters={filters}
					classes={classes}
					sideMenuDropdowns={sideMenuDropdowns}
					isColumnVisibilityDrawerOpen={isColumnVisibilityDrawerOpen}
					setIsColumnVisibilityDrawerOpen={
						setIsColumnVisibilityDrawerOpen
					}
					setSideMenuSearchValue={setSideMenuSearchValue}
					datePickerError={datePickerError}
					datePickerErrorMessage={datePickerErrorMessage}
					handleDateRangeChange={handleDateRangeChange}
					handleSearchFieldChange={handleSearchFieldChange}
					handleRefresh={handleRefresh}
					handlePaginationChange={handlePaginationChange}
					handleOnClickItemsPerPageOption={
						handleOnClickItemsPerPageOption
					}
					handleSideMenuCheckboxChange={handleSideMenuCheckboxChange}
					handleRemoveColumnFilter={handleRemoveColumnFilter}
					handleClearAllFilters={handleClearAllFilters}
					downloadFile={downloadFile}
					columns={columns}
					generateFilterChips={generateFilterChips}
					TopBarActions={TopBarActions}
					SearchEndAdornment={SearchEndAdornment}
					searchInputProps={searchInputProps}
					enableFilters={false}
					enableGrouping={false}
					enableColumnDragging={false}
					enablePagination={false}
					enableStickyHeader={true}
					manualSorting={true}
					enableColumnFilterModes={false}
					enableTopToolbar={false}
					enableColumnFilters={false}
					enableGlobalFilter={false}
					showSearchFields={false}
				/>
			</DialogContent>
			<DialogActions className={classes['m_1']}>
				<Button color="primary" onClick={closePopup}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
}
